import { render, staticRenderFns } from "./MapaSugal.vue?vue&type=template&id=1515d94f&scoped=true&"
import script from "./MapaSugal.vue?vue&type=script&lang=ts&"
export * from "./MapaSugal.vue?vue&type=script&lang=ts&"
import style0 from "./MapaSugal.vue?vue&type=style&index=0&id=1515d94f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1515d94f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1515d94f', component.options)
    } else {
      api.reload('1515d94f', component.options)
    }
    module.hot.accept("./MapaSugal.vue?vue&type=template&id=1515d94f&scoped=true&", function () {
      api.rerender('1515d94f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Inicio/Mapa/MapaSugal.vue"
export default component.exports